<div class="home flex-column flex-start-center">
  <h1 class="home-title">Benvenuto nel backoffice</h1>
  <img class="home-back" src="/assets/img/home.jpg">
</div>

<!-- <mat-tab-group class="tab-content">
    <mat-tab label="Carica promozione" class="tab-content"> 
      <app-promo-manager></app-promo-manager>
    </mat-tab>
    
    <mat-tab label="Ordini" class="tab-content"> 
      <app-order-unlock></app-order-unlock>
    </mat-tab>
    <mat-tab label="Categorie" class="tab-content"> Categorie </mat-tab>
  </mat-tab-group> -->